import { create } from 'zustand';

export interface PermissionItem {
  module: string;
  access: number;
}

interface PermissionState {
  permissions: PermissionItem[];
  // Map for O(1) lookups: { [module]: access }
  permissionMap: Record<string, number>;
  permissionsLoaded: boolean;
  setPermissions: (permissions: PermissionItem[]) => void;
  setPermissionsLoaded: (loaded: boolean) => void;
  clearPermissions: () => void;
}

export const usePermissionStore = create<PermissionState>((set) => ({
  permissions: [],
  permissionMap: {},
  permissionsLoaded: false,
  setPermissions: (permissions) =>
    set({
      permissions,
      permissionMap: Object.fromEntries(permissions.map((p) => [p.module, p.access])),
      permissionsLoaded: true,
    }),
  setPermissionsLoaded: (loaded) => set({ permissionsLoaded: loaded }),
  clearPermissions: () => set({ permissions: [], permissionMap: {}, permissionsLoaded: false }),
}));

export default usePermissionStore;
